export const VERSION = '0.94.0'; // x-release-please-version
